import React from 'react';
import workThumb from '../../assets/images/how-it-works.webp';

function WorkPartHomeEight() {
    return (
        <>
            <div className="appie-how-it-work-area pt-100 pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="how-it-work-thumb text-center">
                                <img loading="lazy" src={workThumb} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-how-it-work-content">
                                <h2 className="title">How It works</h2>
                                <p>Here is how our partnership program works</p>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="how-it-work-box">
                                            <span>1</span>
                                            <p className="title">
                                                <b>Apply</b> : Fill out our partnership application
                                                form to express your interest in joining our
                                                program.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="how-it-work-box">
                                            <span>2</span>
                                            <p className="title">
                                                <b>Approval</b> : Our team will review your
                                                application and contact you with further details.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="how-it-work-box">
                                            <span>3</span>
                                            <p className="title">
                                                <b>Promotion</b> : Once approved, you will receive
                                                marketing materials and unique referral links to
                                                promote our software suite to your network.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="how-it-work-box">
                                            <span>4</span>
                                            <p className="title">
                                                <b>Payments</b> : Commissions will be paid out on a
                                                regular basis as per our partnership agreement,
                                                including recurring monthly commissions for eligible
                                                sales.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WorkPartHomeEight;
